"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const getLastGuardMedicalRecord_1 = require("../../medicalRecords/getLastGuardMedicalRecord");
const entities_1 = require("@umahealth/entities");
const appointmentConverter = {
    toFirestore(appointment) {
        return { ...appointment };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new entities_1.GuardiaAppointment(data);
    },
};
/**
 *
 * @param firestore
 * @param uid
 * @param country 'MX', si no se pone nada el default es AR.
 * @returns El último appointment pendiente para el usuario, sólo tiene sentido en usuarios logeados.
 */
async function getLastPendingAppointmentGuard(firestore, uid, country) {
    let lastMedicalRecord;
    let appointment;
    try {
        lastMedicalRecord = await (0, getLastGuardMedicalRecord_1.getLastGuardMedicalRecord)(firestore, uid);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    if (lastMedicalRecord) {
        const assignationId = lastMedicalRecord.assignation_id;
        const appointmentsURL = country === "MX"
            ? "assignations/bag/MX"
            : "assignations/online_clinica_medica/bag"; // TODO: proximamente assignations/bag/AR
        const appointmentUrlCollectionReference = (0, firestore_1.collection)(firestore, appointmentsURL).withConverter(appointmentConverter);
        const appointmentRef = (0, firestore_1.doc)(appointmentUrlCollectionReference, appointmentsURL, assignationId);
        try {
            appointment = await (0, firestore_1.getDoc)(appointmentRef);
        }
        catch (err) {
            throw new Error(`${err}`);
        }
        if (!appointment.exists()) {
            return undefined;
        }
        return appointment.data();
    }
}
exports.default = getLastPendingAppointmentGuard;
